<template>
    <SectionViewLayout
      title='settings.housekeeper.title'
      :content_state='content_state'
      content_class="house-keeper"
      close_route="settings"
    >
        <template #actions>
          <ActionButton
              @click="onHouseKeeperSearch()"
              v-tooltip='"settings.housekeeper.search"'
              icon='fas fa-search'
              class="popup"
          />
        </template>

        <template #content>
            <form>
                <fieldset>
                    <legend>{{Language.say('settings.housekeeper.find_messages')}}</legend>
                    <div class="control-group">
                        <ul class="control radio-group">
                            <li>
                                <input type="radio" id="hkar_1" name="radio" value="all" v-model="housekeeper_options.type" tabindex="-1">
                                <label for="hkar_1" tabindex="0">{{Language.say('settings.housekeeper.old')}}</label>

                            </li>
                            <li>
                                <input type="radio" id="hkar_2" name="radio" value="seen" v-model="housekeeper_options.type" tabindex="-1">
                                <label for="hkar_2" tabindex="0">{{Language.say('settings.housekeeper.read')}}</label>
                            </li>
                            <li>
                                <input type="radio" id="hkar_3" name="radio" value="unseen" v-model="housekeeper_options.type" tabindex="-1">
                                <label for="hkar_3" tabindex="0">{{Language.say('settings.housekeeper.unread')}}</label>
                            </li>
                            <li>
                                <input type="radio" id="hkar_4" name="radio" value="heavy" v-model="housekeeper_options.type" tabindex="-1">
                                <label for="hkar_4" tabindex="0">{{Language.say('settings.housekeeper.heavy')}}</label>
                            </li>
                        </ul>
                    </div>
                </fieldset>

                <fieldset>
                  <div class="control group top-space">
                      <div class="control">
                          <div class="column-group">
                              <span>{{Language.say('settings.housekeeper.more_than')}}</span>
                              <div class="control-group">
                                  <div class="control">
                                      <span class="select-wrapper">
                                          <select v-model="housekeeper_options.period">
                                              <option value="30">{{Language.say('settings.housekeeper.30_days')}}</option>
                                              <option value="120">{{Language.say('settings.housekeeper.6_months')}}</option>
                                              <option value="365">{{Language.say('settings.housekeeper.1_year')}}</option>
                                          </select>
                                      </span>
                                  </div>
                              </div>

                              <slot v-if="housekeeper_options.type === 'heavy'">
                                <span>{{Language.say('settings.housekeeper.bigger_than')}}</span>
                                <div class="control-group">
                                    <div class="control">
                                        <span class="select-wrapper">
                                            <select v-model="housekeeper_options.size">
                                                <option value="1">1 Mb</option>
                                                <option value="5">5 Mb</option>
                                                <option value="10">10 Mb</option>
                                            </select>
                                        </span>
                                    </div>
                                </div>
                              </slot>

                              <span>{{Language.say('settings.housekeeper.on')}}</span>
                              <div class="select-folder">
                                  <span class="folder" role="button" @click="onFoldersModalOpen()">
                                      <i class="far fa-folder"></i>
                                      {{housekeeper_options.folder.name}}
                                      <span class="close" role="button"></span>
                                  </span>
                                  <ActionButton
                                    @click="onFoldersModalOpen()"
                                    text="settings.housekeeper.change"
                                   />
                              </div>

                            </div>
                      </div>
                  </div>
                </fieldset>

                <div class="submit-desktop">
                    <ActionButton
                        @click="onHouseKeeperSearch()"
                        class="main-action"
                        icon="fas fa-search"
                        text="settings.housekeeper.search"
                    />
                </div>
          </form>
        </template>
    </SectionViewLayout>

    <FoldersSelectModal v-if="folders_modal_visible === true"
      @folderSubmit="onFolderSubmit"
      @modalWindowClose="onFoldersModalClose()"
      :folders_create="false"
    />
</template>

<script setup>
  import {ref, reactive}              from 'vue';
  import {defineEmits, defineProps}   from 'vue';
  import {onBeforeMount}              from 'vue';
  import FoldersSelectModal           from '@/vue/Views/Folders/Modals/FoldersSelectModal.vue';
  import SectionViewLayout            from '@/vue/Layouts/Sections/SectionViewLayout.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import FoldersController            from '@/js/Mailboxes/FoldersController';
  import Language                     from '@/js/Shared/Language/Language';
  import ContentState                 from '@/js/Shared/State/ContentState';
  import SAPOMailConfig               from '@/SAPOMailConfig';

  const emit = defineEmits([
    'houseKeeperSearch',
  ])

  const props = defineProps({
    housekeeper_options: {},
  })

  const content_state         = reactive(new ContentState());
  const folders_modal_visible = ref(false);

  onBeforeMount(() => {
    content_state.setLoadedState(true);
    setFolder(
      FoldersController.mailboxes.folders.all.get(
        SAPOMailConfig.client.folders.alias.inbox
      )
    );
  })

  const onFoldersModalClose = () => {
    setFoldersModalVisibility(false);
  }

  const onFoldersModalOpen = () => {
    setFoldersModalVisibility(true);
  }

  const onFolderSubmit = (folder) => {
    setFolder(folder);
    setFoldersModalVisibility(false);
  }

  const setFolder = (folder) => {
    props.housekeeper_options.folder = folder;
  }

  const setFoldersModalVisibility = (value) => {
    folders_modal_visible.value = value;
  }

  const onHouseKeeperSearch = () => {
    emit('houseKeeperSearch');
  }

</script>
